import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
	selector: 'app-filter',
	templateUrl: './filter.component.html',
	styleUrls: ['./filter.component.scss']
})
export class FilterComponent implements OnInit {
	@Input() columnOptions: any;
	@Input() isGeneratingReport: boolean;
	@Input() btnTitle: string;
	@Output() eventEmitter = new EventEmitter<any>();
	
	form: UntypedFormGroup;
	startDate;
	endDate;
  
  	constructor(private formBuilder: UntypedFormBuilder) { }

  	ngOnInit() {
		this.configureFilter();
  	}
	
	/** 
	 * Groups multiple related controls into a single input form.
	 * Sets value to column field.
	 */
	configureFilter() {
		this.form = this.formBuilder.group({
			availabilityStart: [null],
			availabilityEnd: [null],
			column: [null, Validators.required],
			searchTerm: [null],
			createdDateStart: [null],
			createdDateEnd: [null]
		});

		this.form.get('column').setValue(this.columnOptions[0]);
	}

	/** 
	 * Triggers event emmiter if form is valid.
	 */
	search() {
		if (this.form.valid) {
			this.eventEmitter.emit(this.form.value);
		}
	}

	/** 
	 * Resets the form except the column field.
	 */
	resetForm() {
		 this.form.reset({
			column: this.form.get('column').value
		});
	}

	/** 
	 * Checks whether the search is empty or if the start date is greater than the end date.
	 * @param form An object with form fields value.
	 */
	 validateForm(form: any) {

        if (form.column.value === 'date' || form.column.value === 'datePermition') {

            if (!this.startDate || !this.endDate || (this.startDate > this.endDate)) {

                return true;

            }

        } else if (form.column.value !== 'date' && form.column.value !== 'datePermition' && !form.searchTerm) {

            return true;

        }

    }

	setDate(event, field: string) {
        this[field] = event.value._d;
    }
}
